import React, {Component} from 'react';
import NotificationsList from "../../components/NotificationsList/NotificationsList";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {acceptOrReject, getNotifications, markAsSeen} from "../../store/actions/notification";

class Notifications extends Component {
  componentDidMount() {
    this.props.getNotifications(this.props.auth.user.role);
  }

  markAsSeen(id, role) {
    this.props.markAsSeen(id, role);
  }

  acceptOrReject(id, accepting) {
    this.props.acceptOrReject(id, accepting);
  }

  render() {
    return (
        <main>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-content-center">
                    <h2>Notifications</h2>
                  </div>
                  <div className="card-body overflow-x">
                    <NotificationsList
                        acceptOrReject={this.acceptOrReject.bind(this)}
                        requestToChange={this.props.requestToChange}
                        notifications={this.props.notifications ? this.props.notifications : []}
                        auth={this.props.auth}
                        markAsSeen={this.markAsSeen.bind(this)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
    );
  }
}

Notifications.propTypes = {
  notifications: PropTypes.array,
  getNotifications: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  markAsSeen: PropTypes.func.isRequired,
  requestToChange: PropTypes.array,
  acceptOrReject: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  notifications: state.notification.notifications,
  requestToChange: state.notification.requestToChange,
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  getNotifications: role => dispatch(getNotifications(role)),
  markAsSeen: (id, role) => dispatch(markAsSeen(id, role)),
  acceptOrReject: (id, accepting) => dispatch(acceptOrReject(id, accepting))
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/containers/Notifications/Notifications.jsx